import { createSelector } from 'reselect';
import { canShowActionBar, canShowVideoList } from 'shared/selectors/app-settings';

export const isActionBarVisible = createSelector(
  canShowActionBar,
  canShowVideoList,
  (isActionBarVisible, isVideoListVisible) => isActionBarVisible || isVideoListVisible,
);



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/ui-selectors/ui-selectors.js